import React from 'react';
import PropTypes from 'prop-types';
import { SFNavigationOptions } from '../utils/types';
import css from './MenuOptionsContainer.css';
import MenuOptionsList from './MenuOptionsList';
import PrivacyPolicyLink from 'common/PrivacyPolicyLink';
import TermsOfUseLink from 'common/TermsOfUseLink';

export default class MenuOptionsContainer extends React.Component {

  get mainOptions() {
    if ( this.props.mainOptions.length === 0 ) return null;
    return (
      <MenuOptionsList
        options={this.props.mainOptions}
        updateSection={this.props.updateSection}
        currentSection={this.props.currentSection}
      />
    );
  }

  get studentOptions() {
    if ( this.props.studentOptions.length === 0 ) return null;
    return (
      <MenuOptionsList
        options={this.props.studentOptions}
        updateSection={this.props.updateSection}
        currentSection={this.props.currentSection}
      />
    );
  }

  render() {
    return (
      <div className={css['options-container']} aria-label="Menu Options">
        {this.mainOptions}
        {this.studentOptions}
        <div className={css['policy-container']}>
          <PrivacyPolicyLink />
          <TermsOfUseLink />
        </div>
      </div>
    );
  }
}

MenuOptionsContainer.propTypes = {
  mainOptions: SFNavigationOptions.isRequired,
  studentOptions: SFNavigationOptions.isRequired,
  updateSection: PropTypes.func.isRequired,
  currentSection: PropTypes.string
};
